import {PersonnelEN} from "./personnel/en";
import {AssetEN} from "./assest/en";
import {WageEN} from "./wage/en";
import {TimeKeepingEN} from "./timekeeping/en";
import {ApplicationEN} from "./application/en";


export const HrmEN = {
    ...PersonnelEN,
    ...AssetEN,
    ...WageEN,
    ...TimeKeepingEN,
    ...WageEN,
    ...ApplicationEN
}